import React, { useEffect, useState } from 'react';

import AppShell from '../components/AppShell';
import { getSessionUser, logout } from '../services/sessionService';
import ViewAsBanner from '../components/ViewAsBanner';
import { useGarage } from './GarageContext';
import { plural } from './format';

const initialsOf = (name) => {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '';
  const first = parts[0].charAt(0);
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : '';
  return `${first}${last}`.toUpperCase();
};

// "Garagem" ja representa os veiculos: adicionar fica na garagem e remover, no Perfil.
const NAV = [
  { to: '/client/dashboard', label: 'Garagem', icon: 'home', also: ['/client/newvehicle'] },
  { to: '/client/maintances', label: 'Histórico', icon: 'history' },
  { to: '/client/documents', label: 'Documentos', icon: 'file' },
  { to: '/client/profile', label: 'Perfil', icon: 'user', also: ['/client/vehicles'] },
];

// Moldura da area do cliente ("Minha garagem").
export default function GarageShell({ children }) {
  const { pendingEvaluations } = useGarage();
  const name = localStorage.getItem('NOME_USUARIO') || '';
  const [viewAs, setViewAs] = useState(null);

  useEffect(() => {
    let active = true;
    getSessionUser()
      .then((user) => { if (active && user && user.readOnly) setViewAs(user); })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  const handleLogout = async () => {
    await logout('client');
    window.location.href = '/client/login';
  };

  return (
    <AppShell
      nav={NAV}
      homePath='/client/dashboard'
      homeLabel='Sobre Rodas, minha garagem'
      // A unica "novidade" que a API informa: atendimentos esperando avaliacao.
      alert={{
        count: pendingEvaluations,
        to: '/client/maintances?avaliar=1',
        label: `${pendingEvaluations} ${plural(pendingEvaluations, 'atendimento para avaliar', 'atendimentos para avaliar')}`,
      }}
      profile={{ to: '/client/profile', initials: initialsOf(name) || '?', label: 'Meu perfil' }}
      onLogout={handleLogout}
      banner={viewAs ? <ViewAsBanner name={viewAs.name} /> : null}
    >
      {children}
    </AppShell>
  );
}
